import { RootState } from '@reducers';

export const selectSearchInsurancePolicyUserPageReducer = (state: RootState) =>
  state.userDashboardRouteReducer.searchInsurancePolicyUserPageReducer;
